const origin = window.location.origin;
let BASE_URL = "";
let UPLOAD_URL = "";
let IMAGE_UPLOAD_URL = "";
let APP_APIS_V2_URL = "";

// const prodDomain = "https://web.shelfwatch.io";
const prodDomain = "https://app-web.shelfwatch.io";
// const stageDomain = "https://stage-web.shelfwatch.io";
const stageDomain = "https://app-web.shelfwatch.in";
// const devDomain = "https://dev-web.shelfwatch.io";
const devDomain = "https://app-web.shelfwatch.dev";

// const prodURL = "https://prod-streetsnap-apis.shelfwatch.io";
// const stageURL = "https://stage-streetsnap-apis.shelfwatch.io";
// const devURL = "https://dev-streetsnap-apis.shelfwatch.io";
const prodURL = "https://eb-prod.shelfwatch.io";
const stageURL = "https://app-apis.shelfwatch.in";
const devURL = "https://app-apis.shelfwatch.dev";

if (origin === prodDomain) {
  BASE_URL = prodURL;
  UPLOAD_URL = "https://streetsnap-upload.shelfwatch.io/prod/upload";
  // IMAGE_UPLOAD_URL = "https://prod-streetsnap-apis.shelfwatch.io/";
  IMAGE_UPLOAD_URL = "https://app-web-apis.shelfwatch.io/";
  APP_APIS_V2_URL = "https://app-apis-v2.shelfwatch.io";
} else if (origin === stageDomain) {
  BASE_URL = stageURL;
  UPLOAD_URL = "https://streetsnap-upload.shelfwatch.io/stage/upload";
  // IMAGE_UPLOAD_URL = "https://stage-streetsnap-apis.shelfwatch.io/";
  IMAGE_UPLOAD_URL = "https://app-web-apis.shelfwatch.in/";
  APP_APIS_V2_URL = "https://app-apis-v2.shelfwatch.in";
} else if (origin === devDomain) {
  BASE_URL = devURL;
  UPLOAD_URL = "https://streetsnap-upload.shelfwatch.io/dev/upload";
  // IMAGE_UPLOAD_URL = "https://dev-streetsnap-apis.shelfwatch.io/";
  IMAGE_UPLOAD_URL = "https://app-web-apis.shelfwatch.dev/";
  APP_APIS_V2_URL = "https://app-apis-v2.shelfwatch.dev";
} else {
  BASE_URL = devURL;
  UPLOAD_URL = "https://streetsnap-upload.shelfwatch.io/dev/upload";
  // IMAGE_UPLOAD_URL = "https://dev-streetsnap-apis.shelfwatch.io/";
  IMAGE_UPLOAD_URL = "https://app-web-apis.shelfwatch.dev/";
  APP_APIS_V2_URL = "https://app-apis-v2.shelfwatch.dev";
}

const APP_VERSION = "5.5.2";

export {
  BASE_URL,
  UPLOAD_URL,
  IMAGE_UPLOAD_URL,
  APP_APIS_V2_URL,
  APP_VERSION,
};
